import dayjs from "dayjs";

export type ISODateTimeString = string;

export const localDateTimeToISO = (value: string | null): ISODateTimeString =>
  value ? dayjs(value).toISOString() : "";

export const dayRangeStartToISO = (value: string | null): ISODateTimeString =>
  value ? dayjs(value).startOf("day").toISOString() : "";

export const dayRangeEndToISO = (value: string | null): ISODateTimeString =>
  value ? dayjs(value).endOf("day").toISOString() : "";
